/*
 * Qenova Collection page interactions
 * - Mobile filter sidebar drawer open/close
 * - Sort dropdown change → reload with ?sort_by=X
 * - Filter form change → debounced reload with new ?param string
 */
(function () {
  'use strict';

  // ============================================================
  // 1) Mobile filter sidebar drawer
  // ============================================================
  const sidebar = document.querySelector('[data-qfsb]');
  const toggleBtn = document.querySelector('[data-qcgrid-filter-toggle]');
  const closeBtn = document.querySelector('[data-qfsb-close]');

  const openSidebar = () => {
    if (!sidebar) return;
    sidebar.setAttribute('data-qfsb-open', 'true');
    document.body.style.overflow = 'hidden';
  };
  const closeSidebar = () => {
    if (!sidebar) return;
    sidebar.setAttribute('data-qfsb-open', 'false');
    document.body.style.overflow = '';
  };

  if (toggleBtn) toggleBtn.addEventListener('click', openSidebar);
  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sidebar && sidebar.getAttribute('data-qfsb-open') === 'true') {
      closeSidebar();
    }
  });

  // ============================================================
  // 2) Sort dropdown
  // ============================================================
  const sortSelect = document.querySelector('[data-qcgrid-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page'); // reset to page 1
      window.location.href = url.toString();
    });
  }

  // ============================================================
  // 3) Filter form change → reload with filter params
  // ============================================================
  const filterForm = document.querySelector('[data-qfsb-form]');
  if (filterForm) {
    let debounce;
    const applyFilters = () => {
      const formData = new FormData(filterForm);
      const params = new URLSearchParams();
      // Build params from form fields
      for (const [key, value] of formData.entries()) {
        if (value !== '' && value !== '0') {
          params.append(key, value);
        }
      }
      // Preserve sort_by
      const currentUrl = new URL(window.location.href);
      const sortBy = currentUrl.searchParams.get('sort_by');
      if (sortBy) params.set('sort_by', sortBy);

      const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      window.location.href = newUrl;
    };

    filterForm.addEventListener('change', () => {
      clearTimeout(debounce);
      debounce = setTimeout(applyFilters, 350);
    });

    filterForm.addEventListener('reset', (e) => {
      e.preventDefault();
      window.location.href = window.location.pathname;
    });
  }

  // ============================================================
  // 4) "Mehr laden" — could AJAX-append; here we just let the link nav.
  //    Could enhance later to fetch + append products without reload.
  // ============================================================
})();
